import { APP_CONFIG } from '@core/configs';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const TOKEN_URL = APP_CONFIG.tokenUrl;

export const API_ENDPOINT = {
  auth: {
    loginByCareconneConsole: API_BASE_URL + 'auth/login',
    logout: API_BASE_URL + 'auth/logout',
    verifyRefreshToken: TOKEN_URL + 'ck-pass/token/verify-refresh-token',
    refreshToken: API_BASE_URL + 'auth/refresh-token',
  },
  notifications: {
    controller: APP_CONFIG.apiBaseUrl + 'notification/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    sendTest: 'send-draft/',
    sendFinal: 'send-final/',
    getListUserByRole: 'get-list-user-by-role/',
    sendInQueue: 'send-in-queue/',
    getSendList: 'get-send-list',
  },
  notificationsDetail: {
    controller: APP_CONFIG.apiBaseUrl + 'notifications-detail/',
    getByNotificationsId: 'get-by-id/',
  },
  careconneCompany: {
    controller: API_BASE_URL + 'careconne-company',
    paginate: '/paginate',
    getAll: '/get-all',
    deleteCareconneRole: '/delete-careconne-role',
    updatedXmlStatus: '/updated-xml-status',
    getInfosentLinked: '/get-infosent-linked',
  },
  userRole: {
    controller: APP_CONFIG.apiBaseUrl + 'user-role/',
    paginate: 'paginate',
    getDetails: 'get-details/',
    getSupportStaff: 'get-support-staff/',
    inviteSupportStaff: 'invite-support-staff',
    editSupportStaff: 'edit-support-staff',
    getUserIdByEmail: 'get-user-by-id',
    deleteSupportStaff: 'delete-support-staff',
    deleteAccount: 'delete-account/',
    organizationsName: 'organizations-name',
  },
  help: {
    controller: APP_CONFIG.apiBaseUrl + 'help/',
    getAll: 'get-all/',
    createDraft: 'create-draft',
  },
  loginNotice: {
    controller: APP_CONFIG.apiBaseUrl + 'login-notice/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    createFinal: 'create-final/',
    createDraft: 'create-draft/',
    update: 'update/',
  },
  template: {
    controller: APP_CONFIG.apiBaseUrl + 'template/',
    getAll: 'get-all/',
    getDetail: 'get-detail/',
    deleteTemplate: 'delete-template',
  },
  mstMessage: {
    controller: APP_CONFIG.apiBaseUrl + 'mst-message/',
    getAll: 'get-all/',
    getByIds: 'get-by-ids',
  },
  noSendList: {
    controller: APP_CONFIG.apiBaseUrl + 'no-send-list/',
    excludeSend: 'exclude-send/',
  },
  saucerLog: {
    getLog: APP_CONFIG.apiBaseUrl + 'logs',
    bulkLog: APP_CONFIG.apiBaseUrl + 'logs/bulk',
  },
  version: {
    controller: APP_CONFIG.apiBaseUrl + 'version/',
    getAttachment: 'attachment/',
  },
  consoleRole: {
    controller: APP_CONFIG.apiBaseUrl + 'console-role/',
    getDetails: 'get-details/',
    getPermissionsByMenu: 'get-permissions-by-menu/',
    getRoleDetailsByUser: 'get-role-details-by-user/',
  },
  consoleUserRole: {
    controller: APP_CONFIG.apiBaseUrl + 'console-user-role/',
    getUserAll: 'get-user-all/',
    getUserPermissions: 'get-user-permissions/',
    updateUserRole: 'update/',
  },
};
